export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img7-9d52498d04df8da440350bd66c6daa0a.png";